import { ImmerReducer, createActionCreators, createReducerFunction } from 'immer-reducer';
import {
  EndOfDayActivityName,
  IActivity,
  IEndOfDay,
} from '../../../end-of-day/business-logic/end-of-day-status';

const initialState: IEndOfDay = {
  activity: [],
};

class EndOfDayReducer extends ImmerReducer<IEndOfDay> {
  public setActivity(activity: IActivity[]): void {
    this.draftState.activity = activity;
  }

  public setActivityCompleted(activityName: EndOfDayActivityName): void {
    const filteredActivity = this.draftState.activity.find(value => value.name === activityName);

    if (filteredActivity) {
      filteredActivity.isCompleted = true;
    }
  }

  public resetActivity(): void {
    this.draftState = initialState;
  }
}

export const EndOfDayActions = createActionCreators(EndOfDayReducer);
export const EndOfDayReducerFunction = createReducerFunction(EndOfDayReducer, initialState);
